import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_8 implements Validator {

	public static id = 'CTRL_8';
	private message = 'error.ctr_8';


	public LOG: LogService = new LogService(CTRL_8);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_8.id + '_');

		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const nomWithStepId = map.get(ctrl.value.rgCtrls.nom);
				const prenomWithStepId = map.get(ctrl.value.rgCtrls.prenom);
				const foncWithStepId = map.get(ctrl.value.rgCtrls.fonc);
				const civiliteWithStepId = map.get(ctrl.value.rgCtrls.civilite);
				const nomCtrl = form.controls[nomWithStepId];
				const prenomCtrl = form.controls[prenomWithStepId];
				const foncCtrl = form.controls[foncWithStepId];
				const civiliteCtrl = form.controls[civiliteWithStepId];
				if (nomCtrl?.value.trim.length < 0 || prenomCtrl?.value.trim.length < 0 ||
					foncCtrl?.value.trim.length < 0 || civiliteCtrl?.value.trim.length < 0) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}
}
